import { render, staticRenderFns } from "./appMian.vue?vue&type=template&id=4d1cb644&scoped=true&"
import script from "./appMian.vue?vue&type=script&lang=js&"
export * from "./appMian.vue?vue&type=script&lang=js&"
import style0 from "./appMian.vue?vue&type=style&index=0&id=4d1cb644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1cb644",
  null
  
)

export default component.exports